const configuredUntil = import.meta.env.VITE_BACKGROUND_DB_WORK_PAUSED_UNTIL;
const MAX_TIMER_MS = 2_147_000_000;

export function backgroundDbWorkPauseRemainingMs(nowMs = Date.now()): number {
  if (!configuredUntil?.trim()) return 0;
  const resumeAtMs = Date.parse(configuredUntil);
  if (!Number.isFinite(resumeAtMs)) return 0;
  return Math.max(0, resumeAtMs - nowMs);
}

export function isBackgroundDbWorkPaused(nowMs = Date.now()): boolean {
  return backgroundDbWorkPauseRemainingMs(nowMs) > 0;
}

export function backgroundDbWorkRefetchIntervalMs(
  normalIntervalMs: number,
): number {
  const remainingMs = backgroundDbWorkPauseRemainingMs();
  return remainingMs > 0
    ? Math.min(remainingMs + 250, MAX_TIMER_MS)
    : normalIntervalMs;
}
